import { ChevronRight } from 'lucide-react'

export interface ContentListItemProps {
  title: string
  excerpt?: string
  href: string
  ctaLabel?: string
  className?: string
}

const cardBase =
  'bg-surface-card dark:bg-dark-card border-2 border-ink dark:border-dark-border rounded-[12px] shadow-[2px_2px_0_#111111] dark:shadow-[2px_2px_0_#000000] hover:shadow-[4px_4px_0_#111111] dark:hover:shadow-[4px_4px_0_#000000] hover:-translate-x-px hover:-translate-y-px transition-all duration-150 cursor-pointer'

export function ContentListItem({
  title,
  excerpt,
  href,
  ctaLabel = 'Read more',
  className = '',
}: ContentListItemProps) {
  if (excerpt) {
    return (
      <a
        href={href}
        className={`flex items-start gap-4 p-[18px_22px] ${cardBase} ${className}`}
      >
        <span
          className="w-2.5 h-2.5 rounded-full bg-pro border-2 border-ink shrink-0 mt-[5px]"
          aria-hidden="true"
        />
        <div className="flex flex-col gap-1 min-w-0">
          <span className="font-black text-[17px] text-ink dark:text-dark-ink leading-snug">
            {title}
          </span>
          <span className="text-[13px] font-semibold text-ink-secondary dark:text-dark-ink2 leading-snug">
            {excerpt}
          </span>
          <span className="inline-flex items-center gap-1 text-[12px] font-extrabold text-[#0e7490] dark:text-cyan tracking-[0.03em] mt-1">
            {ctaLabel}
            <ChevronRight className="h-3.5 w-3.5" aria-hidden="true" />
          </span>
        </div>
      </a>
    )
  }

  return (
    <a
      href={href}
      className={`flex items-center justify-between gap-3 px-4 py-3.5 ${cardBase} ${className}`}
    >
      <span className="font-extrabold text-sm text-ink dark:text-dark-ink leading-snug">
        {title}
      </span>
      <span className="inline-flex items-center gap-1 text-[12px] font-extrabold text-[#0e7490] dark:text-cyan tracking-[0.03em] shrink-0">
        {ctaLabel}
        <ChevronRight className="h-3.5 w-3.5" aria-hidden="true" />
      </span>
    </a>
  )
}
